import { Download } from "lucide-react";
import { FileField } from "../../../ui/index.ts";
import { DOCUMENTS, W9_DOWNLOAD_URL, type AgencyDocumentId, type AgencyDocuments } from "./consultant-agency-us.config.ts";
import styles from "./consultant-agency-us.module.css";

interface Props {
  documents: AgencyDocuments;
  errors: Partial<Record<AgencyDocumentId, string>>;
  onChange: (id: AgencyDocumentId, file: File | null) => void;
}

export function AgencyDocumentStep({ documents, errors, onChange }: Props) {
  return (
    <div className={styles.stack}>
      <p className={styles.lead}>Please attach the following documents, as applicable.</p>
      <div className={styles.downloadPanel}>
        <div>
          <h3 className={styles.sectionTitle}>W-9 tax form</h3>
          <p className={styles.lead}>Download, complete and sign the form, then attach it below.</p>
        </div>
        <a href={W9_DOWNLOAD_URL} download className={styles.downloadButton}><Download size={17} aria-hidden />Download W-9 Form</a>
      </div>
      {DOCUMENTS.map(({ id, label, required, hint }) => (
        <FileField
          key={`${id}-${errors[id] ?? ""}`}
          id={`agency-document-${id}`}
          label={label}
          required={required}
          hint={`${hint} PDF, Word, PNG, JPG, or Excel; up to 10 MB.`}
          accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.xlsx"
          stagedFile={documents[id] ?? null}
          error={errors[id]}
          onChange={(file) => onChange(id, file)}
        />
      ))}
    </div>
  );
}
